import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { api as aiAssistantApi } from '../../../actions/AiAssistant/aiAssistantActions';
import AiAssistantMessageList from '../AiAssistantChat/aiAssistantMessageList';
import './aiAssistantHistoryTranscript.scss';

const EMPTY_MESSAGES = fromJS([]);

export default function AiAssistantHistoryTranscript({ labels, sessionId, onBack }) {
  const [conversation, setConversation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setNotFound(false);
    setConversation(null);

    aiAssistantApi.fetchConversation(sessionId).then((result) => {
      if (cancelled) {
        return;
      }
      setLoading(false);
      if (!result) {
        setNotFound(true);
        return;
      }
      setConversation(result);
    });

    return () => { cancelled = true; };
  }, [sessionId]);

  const title = conversation?.title || labels.get('history.untitled', 'Untitled conversation');
  const messages = conversation ? fromJS(conversation.messages) : EMPTY_MESSAGES;
  const showTranscript = !loading && !notFound;

  return (
    <div className="ais-history-transcript">
      <div className="ais-history-transcript-header">
        <button
          className="ais-history-back-btn"
          onClick={onBack}
          aria-label={labels.get('history.button.backToList', 'Back to history')}
        >
          <i className="fa fa-angle-left" />
        </button>
        <div className="ais-history-transcript-title" title={title}>{title}</div>
      </div>

      {loading && <div className="ais-history-state">{labels.get('history.loading', 'Loading...')}</div>}
      {!loading && notFound && (
        <div className="ais-history-state">{labels.get('history.error.notFound', 'This conversation is no longer available.')}</div>
      )}
      {showTranscript && (
        <AiAssistantMessageList
          messages={messages}
          labels={labels}
          showCopy
          showFeedback={false}
        />
      )}
    </div>
  );
}

AiAssistantHistoryTranscript.propTypes = {
  labels: PropTypes.object.isRequired,
  sessionId: PropTypes.string.isRequired,
  onBack: PropTypes.func.isRequired,
};
